var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorizedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#E32424"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44,
    cy: 44,
    r: 39,
    fill: "#E32424"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 34,
    fill: "#E32424"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1886 53.4226H45.4299C45.6609 53.4226 45.85 53.2377 45.85 53.0025V52.5824C45.85 51.6583 45.0981 50.9022 44.1697 50.9022H44.1277C43.9345 49.9403 43.086 49.2178 42.0694 49.2178H39.5491C38.5325 49.2178 37.684 49.9403 37.4908 50.9022H37.4488C36.5205 50.9022 35.7686 51.6583 35.7686 52.5824V53.0025C35.7686 53.2377 35.9576 53.4226 36.1886 53.4226Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9274 44.1473L46.2027 40.7154C46.2279 40.6314 46.2447 40.5432 46.2616 40.4592L46.6144 38.6487H46.6186C47.0765 38.6487 47.5175 38.3841 47.7108 37.9346L47.736 37.8758C48.0006 37.2709 47.7234 36.5694 47.1185 36.3048L43.3715 34.675C42.7709 34.4145 42.0652 34.6918 41.8047 35.2967L41.7795 35.3513C41.6493 35.6453 41.6451 35.9688 41.7627 36.2628C41.8173 36.4098 41.9013 36.54 42.0022 36.6493L40.9184 38.1363C40.3303 38.947 39.9145 39.8963 39.7254 40.8793L39.3726 42.6897C38.9105 42.6855 38.4695 42.9543 38.272 43.4038L38.2468 43.4668C37.9864 44.0675 38.2636 44.7732 38.8643 45.0336L42.6112 46.6635C42.7667 46.7307 42.9263 46.7643 43.0859 46.7643C43.548 46.7643 43.9848 46.4954 44.1823 46.046L44.2075 45.9872C44.3335 45.6973 44.3419 45.3739 44.2243 45.0756C44.1697 44.9328 44.0856 44.8068 43.9806 44.6976L45.0644 43.2064C45.1148 43.135 45.1652 43.0678 45.2114 42.9921L53.663 47.0667C53.8772 47.1675 54.1083 47.2179 54.3393 47.2179C54.5283 47.2179 54.7173 47.1843 54.898 47.1171C55.3054 46.9617 55.6247 46.6593 55.8011 46.2602C55.9733 45.8654 55.9775 45.4243 55.8095 45.021C55.6457 44.6178 55.3348 44.3111 54.9274 44.1473Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5477 35.8469L33.9659 36.2652L51.7344 54.0336L52.1527 54.4519L51.6705 54.7947C46.4973 58.4724 39.2624 58.0104 34.6262 53.3735L33.5477 35.8469ZM33.5477 35.8469L33.2049 36.3289C29.5265 41.5017 29.9894 48.7367 34.6262 53.3735L33.5477 35.8469ZM32.327 55.6728L32.327 55.6728C25.891 49.2367 25.891 38.7631 32.327 32.327C38.7631 25.891 49.2367 25.891 55.6728 32.327C62.1088 38.7631 62.1088 49.2367 55.6728 55.6728C52.4545 58.891 48.2285 60.5 43.9995 60.5C39.7712 60.5 35.5444 58.8909 32.327 55.6728ZM54.0339 51.7346L54.4521 52.1529L54.7949 51.6708C58.4733 46.4981 58.0104 39.2631 53.3735 34.6262L53.3735 34.6262C50.7884 32.042 47.3932 30.7502 43.9995 30.7502C41.305 30.7502 38.6175 31.5778 36.329 33.2049L35.8469 33.5477L36.2652 33.966L54.0339 51.7346Z",
    fill: "white",
    stroke: "#E32424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorizedIcon);
export default __webpack_public_path__ + "static/media/UnauthorizedIcon.52f91212ea04d44e6f88226100e3bd35.svg";
export { ForwardRef as ReactComponent };